var TsUtils = /** @class */ (function () {
    function TsUtils() {
    }
    TsUtils.enumToArray = function (en, keysFilter) {
        var arr = [];
        for (var i in en) {
            if (!isNaN(i) && en.hasOwnProperty(i)) {
                if (!keysFilter || keysFilter(en[i])) {
                    arr.push(parseInt(i, 10));
                }
            }
        }
        return arr;
    };
    TsUtils.randomEnumValue = function (en) {
        var vals = TsUtils.enumToArray(en);
        return vals[Math.floor(Math.random() * vals.length)];
    };
    return TsUtils;
}());
export { TsUtils };
;
//# sourceMappingURL=ts-utils.js.map